// extracted by mini-css-extract-plugin
export default {"item-container":"styles_item-container__rqDfp","change-name-input":"styles_change-name-input__nvh7a","speaker-label":"styles_speaker-label__fmDJr"};